"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgroDrones = void 0;
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Resources_1 = require("../../Resources");
var CardRequirements_1 = require("../CardRequirements");
var Tags_1 = require("../Tags");
var AgroDrones = (function (_super) {
    __extends(AgroDrones, _super);
    function AgroDrones() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.AGRO_DRONES,
            cost: 14,
            tags: [Tags_1.Tags.PLANT, Tags_1.Tags.MARS],
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.temperature(-18); }),
            metadata: {
                cardNumber: 'Pf04',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action('Spend 1 steel and 1 energy to gain 3 plants.', function (eb) {
                        eb.steel(1).energy(1).startAction.plants(3);
                    });
                }),
                description: 'Requires -18° C or warmer.',
            },
        }) || this;
    }
    AgroDrones.prototype.canAct = function (player) {
        return player.steel > 0 && player.energy > 0;
    };
    AgroDrones.prototype.action = function (player) {
        player.deductResource(Resources_1.Resources.STEEL, 1);
        player.deductResource(Resources_1.Resources.ENERGY, 1);
        player.addResource(Resources_1.Resources.PLANTS, 3);
        player.game.log('${0} spent 1 steel and 1 energy to gain 3 plants.', function (b) { return b.player(player); });
        return undefined;
    };
    AgroDrones.prototype.play = function () {
        return undefined;
    };
    return AgroDrones;
}(Card_1.Card));
exports.AgroDrones = AgroDrones;
